module.exports = __webpack_public_path__ + "img/img_jygb.b12c8b5f.svg";